export const prefix = "[zeller.sdk.spa]";

export const debug = (...args: unknown[]) => {
	if (import.meta.env.MODE === "development") {
		console.debug(prefix, ...args.filter((arg) => !isEmpty(arg)));
	}
};

const isEmpty = (val: unknown): boolean => {
	if (val === null || val === undefined) {
		return true;
	}
	if (Array.isArray(val)) {
		return val.length === 0;
	}
	if (typeof val === "object" && !(val instanceof Error)) {
		return Object.keys(val).length === 0;
	}
	return false;
};
